import React, { Component } from "react";
import fixSteve from "./fixSteve";

const baseUrl =
  "https://rl8b1iyh90.execute-api.us-west-2.amazonaws.com/production/";

const stylz = {
  width: "25%",
  flexGrow: 1,
  border: "1px solid gray",
  borderRadius: 5,
  padding: 15,
  cursor: "pointer"
};

class Vote extends Component {
  state = {};
  constructor(props) {
    super(props);
    this.fetchVotes = this.fetchVotes.bind(this);
    this.vote = this.vote.bind(this);
  }
  componentDidMount() {
    this.fetchVotes();
  }

  fetchVotes() {
    fetch(
      "https://rl8b1iyh90.execute-api.us-west-2.amazonaws.com/production/matchups/random",
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        }
      }
    )
      .then(response => response.json())
      .then(data => this.setState(data));
  }

  vote(Winner) {
    fetch(`${baseUrl}${this.state.vote_url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({ Winner })
    }).then(response => {
      if (response.status >= 200 && response.status < 300) {
        this.fetchVotes();
      }
    });
  }

  render() {
    return (
      <div style={{ width: "70%", margin: "30px auto", display: "flex" }}>
        {this.state.contender_1 && (
          <div
            style={stylz}
            onClick={() => this.vote(this.state.contender_1.name)}
            dangerouslySetInnerHTML={{
              __html: fixSteve(this.state.contender_1)
            }}
          />
        )}
        <div style={{ margin: "200px 20px 0 20px" }}>VS</div>

        {this.state.contender_2 && (
          <div
            style={stylz}
            onClick={() => this.vote(this.state.contender_2.name)}
            dangerouslySetInnerHTML={{
              __html: fixSteve(this.state.contender_2)
            }}
          />
        )}
      </div>
    );
  }
}

export default Vote;



// WEBPACK FOOTER //
// ./src/Vote.js